(() => {
  'use strict';
  const root = document.querySelector('#vh-scratch-host');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const config = JSON.parse(root.querySelector('[data-vh-scratch-config]').textContent);
  const teaser = root.querySelector('[data-vh-scratch-teaser]');
  const dialog = root.querySelector('#popup');
  const canvas = root.querySelector('#scratch-canvas');
  const ticket = root.querySelector('#ticket');
  let ctx;
  try { ctx = canvas.getContext('2d'); } catch (_) { ctx = null; }
  const bag = new Image();
  bag.src = 'https://cdn.shopify.com/s/files/1/0865/8147/7702/files/vh-scratch-bag-20261026.png?v=1793005398';
  const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealed = false;
  let dragging = false;
  let activePointer = null;
  let lastPoint = null;
  let moves = 0;
  let currentStep = 'scratch';
  let activeTimer = null;
  let revealTimer = null;
  let transitionTimer = null;
  let feedbackTimer = null;
  let savedOverflow = '';
  let cssWidth = 0;
  let cssHeight = 0;
  let coverReady = false;
  let coverBounds = null;
  const coverageColumns = 32;
  const coverageRows = 32;
  const scratchCoverage = new Uint8Array(coverageColumns * coverageRows);
  let scratchedCells = 0;
  root.dataset.scratchStatus = 'loading';

  function announce(message) {
    root.querySelector('#announcement').textContent = message;
  }

  function showStep(name) {
    clearTimeout(revealTimer);
    clearTimeout(transitionTimer);
    revealTimer = null;
    transitionTimer = null;
    currentStep = name;
    dialog.dataset.step = name;
    if (name === 'email') { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'WbCeVZ']); }
    for (const step of root.querySelectorAll('.step')) {
      step.classList.remove('is-leaving');
      step.hidden = step.id !== `${name}-step`;
    }
    const heading = root.querySelector(`#${name === 'scratch' ? 'popup' : name}-title`);
    dialog.setAttribute('aria-labelledby', heading.id);
    dialog.removeAttribute('aria-describedby');
    if (name === 'scratch') dialog.setAttribute('aria-describedby', 'popup-description');
    heading.focus({ preventScroll: true });
    dialog.scrollTop = 0;
  }

  function transitionTo(name) {
    if (!dialog.open || currentStep === name || transitionTimer !== null) return;
    clearTimeout(revealTimer);
    revealTimer = null;
    root.querySelector(`#${currentStep}-step`).classList.add('is-leaving');
    transitionTimer = setTimeout(() => { transitionTimer = null; showStep(name); }, motionReduced.matches ? 0 : 160);
  }

  function clearStepTimers() {
    clearTimeout(activeTimer);
    clearTimeout(revealTimer);
    clearTimeout(transitionTimer);
    activeTimer = null;
    revealTimer = null;
    transitionTimer = null;
  }

  for (const button of root.querySelectorAll('.primary')) {
    const press = event => {
      if (button.disabled || motionReduced.matches) return;
      const rect = button.getBoundingClientRect();
      const hasCoordinates = event.type === 'pointerdown';
      button.style.setProperty('--press-x', `${hasCoordinates ? event.clientX - rect.left : rect.width / 2}px`);
      button.style.setProperty('--press-y', `${hasCoordinates ? event.clientY - rect.top : rect.height / 2}px`);
      button.classList.remove('is-pressed');
      void button.offsetWidth;
      button.classList.add('is-pressed');
    };
    button.addEventListener('pointerdown', press);
    button.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') press(event); });
    button.addEventListener('animationend', event => { if (event.animationName === 'button-ripple') button.classList.remove('is-pressed'); });
  }

  function paintCover() {
    if (!ctx || revealed || currentStep !== 'scratch' || !bag.complete || !bag.naturalWidth) return;
    const rect = ticket.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    cssWidth = rect.width;
    cssHeight = rect.height;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(cssWidth * ratio);
    canvas.height = Math.round(cssHeight * ratio);
    const scale = Math.min(cssWidth / bag.naturalWidth, cssHeight / bag.naturalHeight);
    const width = bag.naturalWidth * scale;
    const height = bag.naturalHeight * scale;
    coverReady = false;
    try {
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, cssWidth, cssHeight);
      ctx.drawImage(bag, (cssWidth - width) / 2, (cssHeight - height) / 2, width, height);
      ctx.globalCompositeOperation = 'destination-out';
    } catch (_) {
      root.dataset.scratchStatus = 'unavailable';
      return;
    }
    coverBounds = { left: (cssWidth - width) / 2, top: (cssHeight - height) / 2 + height * .2, width, height: height * .8 };
    scratchCoverage.fill(0);
    scratchedCells = 0;
    coverReady = true;
    root.dataset.scratchStatus = 'ready';
    ticket.classList.add('is-ready');
    moves = 0;
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    root.dataset.scratchStatus = 'revealed';
    ticket.classList.add('is-ready');
    ticket.classList.add('is-won');
    dragging = false;
    canvas.classList.add('cleared');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.tabIndex = -1;
    root.querySelector('#prize').removeAttribute('aria-hidden');
    root.querySelector('#scratch-hint').hidden = true;
    const revealButton = root.querySelector('#reveal');
    const moveFocus = document.activeElement === canvas || document.activeElement === revealButton;
    revealButton.hidden = true;
    const claim = root.querySelector('#claim');
    claim.hidden = false;
    announce('You’ve won 10% off your first order. Claim your reward to continue.');
    if (moveFocus) claim.focus({ preventScroll: true });
    revealTimer = setTimeout(() => { revealTimer = null; transitionTo('email'); }, 2200);
  }

  function clearedEnough() {
    return coverReady && scratchedCells / scratchCoverage.length >= .35;
  }

  function markScratch(from, to, radius) {
    if (!coverBounds) return;
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const lengthSquared = dx * dx + dy * dy;
    for (let row = 0; row < coverageRows; row++) {
      const y = coverBounds.top + (row + .5) * coverBounds.height / coverageRows;
      for (let column = 0; column < coverageColumns; column++) {
        const index = row * coverageColumns + column;
        if (scratchCoverage[index]) continue;
        const x = coverBounds.left + (column + .5) * coverBounds.width / coverageColumns;
        const position = lengthSquared ? Math.max(0, Math.min(1, ((x - from.x) * dx + (y - from.y) * dy) / lengthSquared)) : 0;
        const distanceX = x - from.x - position * dx;
        const distanceY = y - from.y - position * dy;
        if (distanceX * distanceX + distanceY * distanceY <= radius * radius) {
          scratchCoverage[index] = 1;
          scratchedCells++;
        }
      }
    }
  }

  function point(event) {
    const rect = canvas.getBoundingClientRect();
    return { x: event.clientX - rect.left, y: event.clientY - rect.top };
  }

  function scratch(from, to) {
    ctx.lineWidth = Math.max(38, cssWidth * .13);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(to.x, to.y, ctx.lineWidth / 2, 0, Math.PI * 2);
    ctx.fill();
    markScratch(from, to, ctx.lineWidth / 2);
  }

  canvas.addEventListener('pointerdown', event => {
    if (!coverReady || revealed || (event.pointerType === 'mouse' && event.button !== 0) || activePointer !== null) return;
    event.preventDefault();
    dragging = true;
    activePointer = event.pointerId;
    lastPoint = point(event);
    try { canvas.setPointerCapture(event.pointerId); } catch (_) {}
    scratch(lastPoint, lastPoint);
  });
  canvas.addEventListener('pointermove', event => {
    if (!dragging || revealed || event.pointerId !== activePointer) return;
    event.preventDefault();
    const nextPoint = point(event);
    scratch(lastPoint, nextPoint);
    lastPoint = nextPoint;
    if (++moves % 5 === 0 && clearedEnough()) reveal();
  });
  const endScratch = event => {
    if (event.pointerId !== activePointer) return;
    dragging = false;
    activePointer = null;
    if (!revealed && clearedEnough()) reveal();
  };
  canvas.addEventListener('pointerup', endScratch);
  canvas.addEventListener('pointercancel', endScratch);
  canvas.addEventListener('lostpointercapture', endScratch);
  canvas.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); reveal(); }
  });
  root.querySelector('#reveal').addEventListener('click', reveal);
  root.querySelector('#claim').addEventListener('click', () => transitionTo('email'));

  const storageKey = 'vh-scratch-native-v1';
  const read = key => {
    try { return JSON.parse(localStorage.getItem(storageKey + '-' + key)); }
    catch (_) { return null; }
  };
  const write = (key, value) => {
    try { localStorage.setItem(storageKey + '-' + key, JSON.stringify(value)); }
    catch (_) {}
  };
  const teaserPreview = new URLSearchParams(location.search).get('vh_teaser_preview') === '1';
  const teaserDismissedAt = read('teaser-dismissed');
  let teaserClosed = !teaserPreview && !!teaserDismissedAt && Date.now()-teaserDismissedAt < config.dismissDays*86400000;
  let submitted = !!read('submitted');
  let dismissedHere = false;
  let otherFormOpen = false;
  let known = !!config.loggedIn;
  let identityChecked = known;
  let checkingIdentity = false;
  let previousFocus = null;
  const started = Date.now();
  const excluded = (config.exclusions || '').split(/[\n,]/).map(s => s.trim().toLowerCase()).filter(Boolean);
  const path = location.pathname.toLowerCase();
  const allowed = ['index','product','collection','blog','article','page','search'].includes(config.pageType)
    && !/\/(cart|checkout|checkouts|account|accounts|policies|apps)(\/|$)/i.test(path)
    && !excluded.some(s => path.split('/').includes(s) || (config.pageHandle || '').toLowerCase() === s);
  const forcePreview = teaserPreview || new URLSearchParams(location.search).get('vh_scratch_preview') === '1';
  const formReady = () => !!root.querySelector('#email-step form.klaviyo-form');

  function closePopup() {
    clearStepTimers();
    if (!dialog.open) return;
    dragging = false;
    activePointer = null;
    dialog.close();
    document.body.style.overflow = savedOverflow;
    dismissedHere = true;
    write('dismissed', Date.now());
    teaser.hidden = teaserClosed || submitted || known || otherFormOpen;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
  }

  function openPopup() {
    if (dialog.open || !allowed || (!forcePreview && (submitted || known || otherFormOpen))) return;
    previousFocus = document.activeElement;
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    teaser.hidden = true;
    dialog.showModal();
    showStep(currentStep);
    if (!revealed) requestAnimationFrame(paintCover);
  }

  root.querySelector('#close').addEventListener('click', closePopup);
  dialog.addEventListener('cancel', event => {event.preventDefault();closePopup();});
  root.querySelector('[data-vh-scratch-teaser-open]').addEventListener('click', openPopup);
  root.querySelector('[data-vh-scratch-teaser-close]').addEventListener('click', event => {
    event.stopPropagation();
    teaserClosed = true;
    teaser.hidden = true;
    write('teaser-dismissed', Date.now());
  });
  function legacyCopyCoupon(code) {
    const field = document.createElement('textarea');
    const focusBeforeCopy = document.activeElement;
    field.value = code;
    field.readOnly = true;
    field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;pointer-events:none';
    dialog.appendChild(field);
    try {
      field.focus({ preventScroll: true });
      field.select();
      field.setSelectionRange(0, code.length);
      return document.execCommand('copy') === true;
    } catch (_) {
      return false;
    } finally {
      field.remove();
      if (focusBeforeCopy && focusBeforeCopy.isConnected) focusBeforeCopy.focus({ preventScroll: true });
    }
  }

  function couponCopyFeedback(button, copied) {
    let feedback = root.querySelector('[data-vh-copy-feedback]');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.className = 'form-trust';
      feedback.setAttribute('data-vh-copy-feedback', '');
      feedback.setAttribute('role', 'status');
      button.closest('.klaviyo-coupon').appendChild(feedback);
    }
    feedback.textContent = copied ? config.copiedText : config.copyErrorText;
    button.dataset.copyState = copied ? 'copied' : 'manual';
    if (!copied) {
      const selection = window.getSelection();
      const range = document.createRange();
      const label = Array.from(button.querySelectorAll('div,span')).find(element => element.textContent.trim() === button.dataset.vhCouponCode) || button;
      range.selectNodeContents(label);
      if (selection) { selection.removeAllRanges(); selection.addRange(range); }
    }
  }

  async function copyCoupon(button, code) {
    if (button.dataset.copyState === 'copying') return;
    button.dataset.copyState = 'copying';
    let copied = false;
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(code);
        copied = true;
      } else {
        copied = legacyCopyCoupon(code);
      }
    } catch (_) {
      copied = legacyCopyCoupon(code);
    }
    couponCopyFeedback(button, copied);
  }

  root.addEventListener('click', event => {
    const button = event.target.closest('.klaviyo-coupon button');
    if (!button || !root.contains(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const code = button.dataset.vhCouponCode || button.innerText.trim().split(/\s/)[0];
    if (!/^[A-Z0-9-]{6,30}$/.test(code)) return;
    button.dataset.vhCouponCode = code;
    copyCoupon(button, code);
  }, true);

  root.querySelector('#email-step').addEventListener('click', event => {
    const target = event.target.closest('a,button');
    if (target && /get yours|start shopping|shop now/i.test(target.textContent) && root.querySelector('.klaviyo-coupon')) {
      event.preventDefault();
      event.stopPropagation();
      closePopup();
    }
  });
  root.querySelector('#email-step').addEventListener('pointerdown', event => {
    const button = event.target.closest('.klaviyo-form-button');
    if (!button) return;
    const box = button.getBoundingClientRect();
    button.style.setProperty('--press-x', (event.clientX-box.left)+'px');
    button.style.setProperty('--press-y', (event.clientY-box.top)+'px');
    button.classList.remove('is-pressed');
    void button.offsetWidth;
    button.classList.add('is-pressed');
  });

  function matchFields() {
    const name = root.querySelector('input[autocomplete="given-name"]');
    const email = root.querySelector('input[type="email"]');
    if (name) name.placeholder = 'Your name';
    if (email) email.placeholder = 'Your email address';
    if (root.querySelector('.klaviyo-coupon')) {
      submitted = true;
      write('submitted', true);
      teaser.hidden = true;
    }
  }
  const formObserver = new MutationObserver(matchFields);
  formObserver.observe(root.querySelector('#email-step'),{childList:true,subtree:true});
  matchFields();

  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (detail.formId === config.formId) {
      if (detail.type === 'submit') {
        submitted = true;
        write('submitted', true);
        teaser.hidden = true;
      }
      return;
    }
    if (detail.type === 'open') {
      otherFormOpen = true;
      teaser.hidden = true;
      if (dialog.open) closePopup();
    }
    if (detail.type === 'close') otherFormOpen = false;
  });

  async function checkIdentity() {
    if (identityChecked || checkingIdentity) return;
    if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') {
      identityChecked = Date.now() - started >= 2500;
      root.dataset.identityStatus = identityChecked ? 'unavailable' : 'waiting';
      return;
    }
    checkingIdentity = true;
    let identityTimer;
    try {
      const identified = await Promise.race([
        window.klaviyo.isIdentified(),
        new Promise(resolve => { identityTimer = setTimeout(() => resolve(null), 2500); })
      ]);
      known = identified === true;
      root.dataset.identityStatus = identified === null ? 'unavailable' : known ? 'known' : 'anonymous';
    } catch (_) {
      known = false;
      root.dataset.identityStatus = 'unavailable';
    } finally {
      clearTimeout(identityTimer);
      identityChecked = true;
      checkingIdentity = false;
    }
  }

  async function maybeOpen() {
    root.dataset.displayStatus = !allowed ? 'excluded' : dialog.open ? 'open' : otherFormOpen ? 'other-form' : !config.enabled ? 'disabled' : submitted ? 'submitted' : dismissedHere ? 'dismissed-session' : 'checking';
    if (!allowed || dialog.open || otherFormOpen || (!forcePreview && (!config.enabled || submitted || dismissedHere))) return;
    if (teaserPreview) { teaser.hidden = teaserClosed; return; }
    await checkIdentity();
    if (!forcePreview && (!identityChecked || known)) { root.dataset.displayStatus = known ? 'known-visitor' : 'identity-pending'; return; }
    const dismissed = read('dismissed');
    if (!forcePreview && dismissed && Date.now()-dismissed < config.dismissDays*86400000) {
      teaser.hidden = teaserClosed || submitted || known || otherFormOpen;
      root.dataset.displayStatus = 'dismissed';
      return;
    }
    const otherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(element => {
      if (element === dialog || element.closest('details:not([open])')) return false;
      const box = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return box.width > 0 && box.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
    });
    if (otherModal) {root.dataset.displayStatus='other-modal';return;}
    const height = Math.max(1,document.documentElement.scrollHeight-innerHeight);
    root.dataset.displayStatus='waiting-trigger';
    if (forcePreview || (Date.now()-started >= config.delay*1000 && scrollY/height*100 >= config.scroll)) openPopup();
  }
  bag.addEventListener('load', () => {if(!coverReady || (moves===0&&!dragging))paintCover();});
  bag.addEventListener('error', () => {root.dataset.scratchStatus = 'image-unavailable';});
  const resizeObserver = new ResizeObserver(() => {
    if (Math.abs(ticket.getBoundingClientRect().width-cssWidth)>1) paintCover();
  });
  resizeObserver.observe(ticket);
  window.addEventListener('scroll',maybeOpen,{passive:true});
  const polling = setInterval(maybeOpen,750);
  window.addEventListener('pagehide',()=>{clearInterval(polling);clearStepTimers();formObserver.disconnect();resizeObserver.disconnect();},{once:true});
  maybeOpen();
})();


